import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { PricingDiscountsView } from './discounts/discounts';
import { PricingListsView } from './lists/lists';

export const PricingView = angular
  .module('acme.view.application.pricing', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.pricing.controllers',
    'acme.view.application.pricing.sidebar.controllers',
    PricingListsView,
    'acme.view.application.pricing.categories',
    PricingDiscountsView,
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const pricing = {
      name: 'application.pricing',
      url: '/pricing',
      views: {
        'subview-main': {
          controller: 'PricingController',
          templateUrl: 'views/application/views/pricing/pricing.tpl.html',
        },
      },
      data: {
        pageTitle: 'Pricing',
      },
    };

    $stateProvider.state(pricing);
  }).name;
